module.exports = __webpack_public_path__ + "img/Secure-Sharing.e532e9a2.webp";